import loadGmap from './loadGmap';

$(function () {
    const $map = $('#map');

    loadGmap({key: $map.data('api-key')}).then(function () {
        const latitude = $map.data('latitude');
        const longitude = $map.data('longitude');
        const zoom = $map.data('zoom');
        const markerIcon = $map.data('marker');

        const map = new google.maps.Map($map.get(0), {
            center: new google.maps.LatLng(latitude, longitude),
            zoom: zoom,
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}]
        });

        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(latitude, longitude),
            map: map,
            icon: {
                url: markerIcon,
                size: new google.maps.Size(62, 93),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(31, 93),
            }
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/map.js
// module id = 7
// module chunks = 0